import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import CreateCampaignDialogErrorMixin from './create-campaign-dialog-error-mixin';

@Component
export default class CreateCampaignDialogFlowOfferErrorsMixin extends mixins(CreateCampaignDialogErrorMixin) {
  getOfferErrorCondition(ruleIndex: number, pathIndex: number, offerIndex: number): any[] {
    return [
      'rules', ruleIndex + 1,
      'paths', pathIndex + 1,
      'offers', offerIndex + 1
    ];
  }

  get offerGeneralErrorCondition() {
    return [ 'id' ];
  }

  get isGeneralError() {
    return this.getInvalidFieldsError(this.offerGeneralErrorCondition);
  }

  get generalErrorMessages() {
    return this.getMessages(this.isGeneralError);
  }

  get offerWeigthErrorCondition() {
    return [ 'weight' ];
  }
  
  get isWeigthError() {
    return this.getInvalidFieldsError(this.offerWeigthErrorCondition);
  }

  get weigthErrorMessages() {
    return this.getMessages(this.isWeigthError);
  }
}